/**
  Handles drop-down menus.
*/
export default function navMenu() {

    const navMenu = document.getElementById('menu-global');
        console.log(77777);

    if(! navMenu) {
        console.log('Menu #menu-global font found');
        return;
    }

    const menuItems = document.querySelectorAll('#menu-global > li');

    const itemsWithChildren = document.querySelectorAll('#menu-global .menu-item-has-children');

    if(! itemsWithChildren.length) {
        return;
    }

    /*  adds a parent link for nav items with a submenu
    let item;
    //let containerWidth = document.querySelector('.site-branding-top-strip').clientWidth;
    //Add "All" link to submenu that links to top level page
    itemsWithChildren.forEach( item => {
        let link = item.firstChild;
        let subMenu = item.querySelector('.sub-menu');
        console.log(item);
    //    subMenu.style.width = `${containerWidth}px`;

      //  li.innerHTML = `<a href="${link.href}">${link.textContent} - All</a>`;
      if(itemsWithChildren.length > 1) {
          let li = document.createElement('li');
          li.innerHTML = `<a href="${link.href}">Overview</a>`;
          subMenu.prepend(li);
      }
    }); */

    document.addEventListener('click', ev => {

        //  let itemWithSubmenuClicked = null;

        const itemWithSubmenuClicked = ev.target.closest('.menuGlobal .menu-item-has-children');

        // a click anywhere else in the document hides the submenu if displayed
        if(! itemWithSubmenuClicked) {
            itemsWithChildren.forEach( itemWithChildren => {
                itemWithChildren.classList.remove('show-sub-menu');
            })
            return;
        }

        // if link inside submenu clicked follow link
        if(ev.target.closest('.menuGlobal .sub-menu')) {
            return;
        }

        ev.preventDefault();

        const pageX = ev.pageX;
        const pageY = ev.pageY;


        const submenu = itemWithSubmenuClicked.querySelector('.sub-menu');
        const dims = itemWithSubmenuClicked.getBoundingClientRect();

       // console.log(dims.bottom);

       let left = Math.round(dims.left);
       const top =  Math.round(dims.bottom) + 10;

        if(screen.width - left < 250) {
            left = screen.width - 270;
        }

        if(left < 0) {
            left = 10;
        }
 
        submenu.style.left = left + 'px';
        submenu.style.top = top + 'px';

        itemWithSubmenuClicked.classList.toggle('show-sub-menu');
    });
}

